// extracted by css-extract-rspack-plugin
export default {"cls1":"SmallAccountMenuButton-cls1_bQA","cls2":"SmallAccountMenuButton-cls2_cAz SmallAccountMenuButton-cls1_bQA"};